import { FormsInvitationPage } from 'pages/FormsInvitation/FormsInvitationPage';
import { IntakeFormPage } from 'pages/IntakeForm/IntakeFormPage';
import { NotFoundPage } from 'pages/NotFound/NotFoundPage';
import { OnlineBookingPage } from 'pages/OnlineBooking/OnlineBookingPage';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { BookingPath, FormPath, IntakeFormPath } from 'routes/Paths';

export const Routes: React.FC = () => {
    return (
        <Switch>
            <Route exact path={BookingPath} component={OnlineBookingPage} />
            <Route exact path={IntakeFormPath} component={IntakeFormPage} />
            <Route exact path={FormPath} component={FormsInvitationPage} />
            <Route exact path="*" component={NotFoundPage} />
            <Redirect to="*" />
        </Switch>
    );
};
